import { Checkbox as ChackraCheckbox } from '@chakra-ui/react';

export const CheckboxRoot = ChackraCheckbox.Root;
export const CheckboxHiddenInput = ChackraCheckbox.HiddenInput;
export const CheckboxControl = ChackraCheckbox.Control;
export const CheckboxIndicator = ChackraCheckbox.Indicator;
export const CheckboxLabel = ChackraCheckbox.Label;
